export default {
  heading: {
    widgetName: "captain",
    widgetID: "107",
    widgetWidth: "3",
    cardCount: "4",
    layoutName: "lob_widget",
    headline: "",
    subHeadline: "",
    showMoreURL: "",
    gtmParameters: {
      event: "trackEventNoEcommerce",
      eventActionClick: "click",
      eventActionView: "view",
      eventCategory: `riderbenefits | captain`,
      eventLabelCardClick: `riderbenefits | {{cardtitle}} | {{cardwidth}} | {{cardposition}} | {{redirecturl}}`,
      eventLabelHeadlineClick: `riderbenefits | headline | {{headline}}`,
      eventLabelView: `riderbenefits`,
    },
  },

  data: [
  ],
}
